
import React from 'react';
import { Memory } from '@/types/memory';
import MemoryCard from './MemoryCard';

interface MemoryListProps {
  memories: Memory[];
}

const MemoryList = ({ memories }: MemoryListProps) => {
  if (memories.length === 0) {
    return (
      <div className="text-center py-10">
        <p className="text-gray-500">No memories found for this day.</p>
        <p className="text-sm mt-2">
          As you add more quotes and milestones, they'll appear here on their anniversary.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {memories.map((memory) => (
        <MemoryCard key={memory.id} memory={memory} />
      ))}
    </div>
  );
};

export default MemoryList;
